import styles from "./styles.scss";
import { NothingSelected } from "@/assets/illustrations";

export const NoItemsSelected = () => {
  return (
    <div className={styles.container}>
      <NothingSelected />
      <h2 className={styles.title}>No requests selected</h2>
      <div className={styles.text}>Select a request to view it</div>
    </div>
  );
};
